<router-outlet></router-outlet>
<app-ai-support-chat *ngIf="!isAdminPage"></app-ai-support-chat>
